import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { roundFloat } from '@/utils/common';
import { useLang } from '@/app/utils/useLang';
import EcoVideo from 'eco-design/base/eco-video';
import { EU_SITE } from '@/constants';
import getLocal from '@/app/utils/getLocal';

const SolarInput: FC = () => {
    const { t } = useLang('theProduct.solarinput');
    const { locale } = getLocal();
    const videoRef = useRef<HTMLVideoElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const [showMark, setShowMark] = useState(false);
    const [showNumber, setShowNumber] = useState(false);

    const isNA = ['us', 'ca'].includes(locale);

    useEffect(() => {
        if (typeof window === 'undefined' || !videoRef.current || !canvasRef.current) return;
        // const video = videoRef.current;
        // const canvas = canvasRef.current;
        // if (!video) return;
        // canvas.width = canvas.clientWidth;
        // canvas.height = canvas.clientHeight;
        // const ctx = canvas.getContext('2d');
        // const dpr = window.devicePixelRatio || 1;
        // ctx?.scale(dpr, dpr);
        // (ctx as CanvasRenderingContext2D).imageSmoothingEnabled = false;

        // const handleDrawImage = () => {
        //     console.log('handleDrawImage');
        //     ctx?.clearRect(0, 0, canvas.width, canvas.height);
        //     ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
        // };

        // const sceneA = AniContainer.create({
        //     triggerElement: `.${styles.SolarInput}`,
        //     triggerHook: 1,
        //     offset: '100%',
        //     duration: '500%',
        //     onProcess: (percent: number) => {
        //         if (!video) return;
        //         const duration: number = video.duration;
        //         if (percent * 100 > 10) {
        //             setShowMark(false);
        //         }
        //         let currentTime = roundFloat(duration * percent, 2) || 0;
        //         currentTime = Math.round(currentTime * 100) / 100;
        //         video.currentTime = currentTime;
        //         handleDrawImage();
        //         if (percent * 100 > 10 && percent * 100 <= 20) {
        //             setShowMark(true);
        //         } else if (percent * 100 > 90 && percent * 100 <= 100) {
        //             setShowNumber(true);
        //         } else {
        //             setShowNumber(false);
        //             setShowMark(false);
        //         }
        //     },
        // });
        // video.currentTime = 0.01;
        // handleDrawImage();
        const handleTimeupdate = () => {
            const duration = videoRef.current?.duration || 10;
            const currentTime = videoRef.current?.currentTime || 0;
            const percent = (currentTime / duration) * 100;
            if (percent <= 10) {
                setShowMark(false);
                setShowNumber(false);
            } else if (percent > 10 && percent <= 70) {
                setShowMark(true);
            } else if (percent > 70 && percent <= 100) {
                setShowNumber(true);
                setShowMark(false);
            } else {
                setShowNumber(false);
            }
        };
        videoRef.current?.addEventListener('timeupdate', handleTimeupdate);
        return () => videoRef.current?.removeEventListener('timeupdate', handleTimeupdate);
    }, []);

    return (
        <section className={styles.SolarInput}>
            <div className="video-box">
                <div className="video-box-relative">
                    <video className="video-elem" ref={videoRef} playsInline muted autoPlay loop>
                        {!isNA && <source src="https://websiteoss.ecoflow.com/upload/video/1745925194662/pc-4mtt.mp4" />}
                        {isNA && <source src="https://websiteoss.ecoflow.com/upload/video/1746173086399/%E5%8C%97%E7%BE%8E4MPPTPC%E7%AB%AF_1.mp4" />}
                    </video>
                    <canvas ref={canvasRef} />
                    <div className={`solar-input-text ${showMark ? 'show' : ''}`}>
                        {EU_SITE.includes(locale) && <p className="solar-input-label">{t('solarinput_more')}</p>}
                        <p className="solar-input-title">
                            {t('solarinput_title')}
                            {locale === 'de' ? <sup>#</sup> : ''}
                        </p>
                        <p className="solar-input-subtitle">{t('solarinput_subtitle')}</p>
                    </div>
                    <div className={`solar-mixinput ${showNumber ? 'show' : ''}`}>{t('solarinput_3200w')}</div>
                </div>
            </div>
            <div className="video-box-mobile">
                {!isNA && <EcoVideo pc="https://websiteoss.ecoflow.com/upload/video/1745925203855/m-4mtt.mp4" loop autoPlay />}
                {isNA && (
                    <EcoVideo
                        pc="https://websiteoss.ecoflow.com/upload/video/1746173086208/%E5%8C%97%E7%BE%8E4MPPT%E7%A7%BB%E5%8A%A8%E7%AB%AF_1.mp4"
                        loop
                        autoPlay
                    />
                )}
                <div className="solar-input-mobilecontext">
                    {EU_SITE.includes(locale) && <p className="solar-input-label">{t('solarinput_more')}</p>}
                    <p className="solar-input-title">
                        {t('solarinput_title')}
                        {locale === 'de' ? <sup>#</sup> : ''}
                    </p>
                    <p className="solar-input-subtitle">{t('solarinput_subtitle')}</p>
                    <div className="solar-mixinput-mobile">{t('solarinput_3200w')}</div>
                </div>
            </div>
        </section>
    );
};

export default SolarInput;
